import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const ArrowRight = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M13.9394 18L20 12M20 12L13.9394 6M20 12H4'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M13.4062 5.47266C13.6795 5.1966 14.1144 5.17699 14.4102 5.41602L14.4668 5.4668L20.5273 11.4668C20.6696 11.6077 20.75 11.7998 20.75 12C20.75 12.2002 20.6696 12.3923 20.5273 12.5332L14.4668 18.5332C14.1724 18.8244 13.6976 18.8216 13.4062 18.5273C13.1151 18.233 13.1178 17.7581 13.4121 17.4668L18.1768 12.75H4C3.58579 12.75 3.25 12.4142 3.25 12C3.25001 11.5858 3.58579 11.25 4 11.25H18.1768L13.4121 6.5332L13.3604 6.47656C13.1184 6.18327 13.1332 5.74874 13.4062 5.47266Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
